<template>
  <div>
    <div> <el-button   @click="openCate()"  class="category add" style="">新增</el-button></div>

  <el-table
      id="table"
      :data="tableData"
      style="width: 100%">
    <el-table-column
        label="ID"
        width="180">
      <template slot-scope="scope">
        <span style="" >{{ scope.row.id }}</span>
      </template>
    </el-table-column>
    <el-table-column
        label="历程年代"
        >
      <template slot-scope="scope">
        <span style="" v-html="scope.row.h_title"></span>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="180">
      <template slot-scope="scope">
        <el-button size="mini" @click="openCate(scope.row.id)">编辑</el-button>
        <el-button
            size="mini"
            type="danger"
            @click="deleteCate(scope.$index,scope.row)">删除</el-button>
      </template>
    </el-table-column>

  </el-table>
    <Dialog  :id='id' :show.sync="dialogVisible" @dialogShowChange="dialogShowChange"></Dialog>

  </div>
</template>
<script>
import axios from "axios";
import Dialog from "@/views/pages/getHistoryView.vue"

export default {
  name: "HistoryView",
  data() {
    return {
      dialogVisible: false, //当前的dialog是不是显示
      tableData: [],
      id: '',
    }
  },
  components:{
    Dialog,
  },
  created() {
    this.getCate();

  },
  methods: {
    openCate(id){
      this.id = id
      this.dialogVisible =true
    },
    dialogShowChange(val){
      this.dialogVisible = val
      this.getCate();
    },
    onSubmit() {
      this.getCate()
    },
    getCate(){
      axios.get('/api/History/index.html').then((res)=>{
        this.tableData = res.data.data;
      });
    },
    deleteCate(index,row){
      let tdata = this.tableData;
      this.$confirm("是否确认删除","提示",{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
      }).then(function (){
        axios.delete('/api/History/deleteHistory.html',{data:{id:row.id}}).then((res)=>{
          tdata.splice(index, 1);
          alert(res.data.msg)
        });
      }).catch(function (){

      })

    }
  }
};
</script>
<style>
/*.el-table tr{height: 40px;}*/
/*#table.el-table .el-table__cell{padding: 0;}*/
</style>